import { presets } from '../../../data';

const presetsFunc = (state = presets) => state;

export default presetsFunc;